'use es6';

import { reduce } from '../../lib/async';
import { configure as metrics } from './metrics';
const mutators = [metrics];
export default (config => {
  return reduce(mutators, (mutated, mutator) => mutator(mutated), config);
});